var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeetcode(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 -2 20 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    fill: "#4d4d4e",
    d: "M14.258,11.984a.922.922,0,0,1,0,1.3l-1.6,1.595a3.85,3.85,0,0,1-5.375.05l-.025-.025h0L4.424,12.127l-.017-.016h0a3.94,3.94,0,0,1-.962-1.544,3.815,3.815,0,0,1-.22-1.046,3.573,3.573,0,0,1,.343-1.69A3.451,3.451,0,0,1,4.175,6.9L6.744,4.151h0l3.6-3.859a.92.92,0,1,1,1.343,1.259L10.337,3a3.875,3.875,0,0,1,1.859.79L14.53,5.678a.92.92,0,0,1-1.155,1.433L11.041,5.224a2.322,2.322,0,0,0-2.954.185L5.518,8.161a1.683,1.683,0,0,0-.365.607,1.731,1.731,0,0,0-.078.342,1.8,1.8,0,0,0-.011.352,1.959,1.959,0,0,0,.057.355,2.11,2.11,0,0,0,.572.977L8.557,13.6a2.014,2.014,0,0,0,2.8-.025l1.6-1.6A.918.918,0,0,1,14.258,11.984Zm1.6-3.44H9.078a.921.921,0,0,0,0,1.842H15.86a.921.921,0,0,0,0-1.842Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeetcode);
export default __webpack_public_path__ + "static/media/leetcode.5228b01df6da9a567f320d99e760f318.svg";
export { ForwardRef as ReactComponent };